import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { CookieSettingsLink } from './consent/CookieSettingsLink';
import { useLegal } from '../lib/legal-context';
import { PORTAL_ENABLED } from '../lib/feature-flags';

export function Footer() {
  const legal = useLegal();
  return (
    <footer className="site-ft">
      <div className="container">
        <div className="fca-strip">
          <strong>{legal.fca_perimeter_notice.split('.')[0]}.</strong>
          {' '}
          {legal.fca_perimeter_notice.split('.').slice(1).join('.').trim()}
          {' '}
          <Link
            to="/regulatory"
            style={{
              color: 'var(--accent)',
              borderBottom: '1px solid color-mix(in oklab, var(--accent) 40%, transparent)',
              whiteSpace: 'nowrap',
              fontWeight: 500,
            }}
          >
            Read our regulatory position →
          </Link>
        </div>

        <div className="cols">
          <div>
            <Logo />
            <p style={{ marginTop: 16, fontSize: 13, color: 'var(--fg-mute)', maxWidth: 320 }}>
              Strategic insights, B2B capital introductions and trade-instrument facilitation
              for sophisticated body corporates across the UK, EU, GCC, India and Southeast Asia.
            </p>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">Trade Instruments</Link></li>
              <li><Link to="/services">Capital Introductions</Link></li>
              <li><Link to="/services">Projects &amp; Infrastructure</Link></li>
              <li><Link to="/services">Research &amp; Intelligence</Link></li>
              <li><Link to="/services">Corporate Services</Link></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Omega</Link></li>
              <li><Link to="/regulatory">Regulatory position</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              {PORTAL_ENABLED && <li><Link to="/portal">Client portal</Link></li>}
              {PORTAL_ENABLED && <li><Link to="/admin" style={{ opacity: 0.7 }}>Operator portal →</Link></li>}
            </ul>
          </div>
          <div>
            <h4>Offices</h4>
            <ul>
              <li>London — The Long Lodge, 265–269 Kingston Rd, Wimbledon SW19 3NW</li>
              <li>Dubai — Office No 4101-4102 Churchill Tower, Business Bay</li>
              <li>India — 80 Sanjana Park, Kannadia Rd, Indore 452016</li>
            </ul>
          </div>
        </div>

        <div className="legal">
          <span>© {new Date().getFullYear()} Omega Trade and Finance Ltd · Company No. 17206902 · Registered in England &amp; Wales</span>
          <span style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
            <Link to="/privacy">Privacy</Link>
            <Link to="/cookies">Cookies</Link>
            <CookieSettingsLink />
            <Link to="/gdpr">GDPR</Link>
            <Link to="/terms">Terms of Business</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
